import React from "react";

const spinnerStyles = {
  overlay: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(72, 71, 71, 0.54)", // slightly darker semi-transparent
    zIndex: 1000,
    flexDirection: "column",
    gap: "16px",
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    cursor: 'wait'
  },
  spinner: {
    width: 100,
    height: 100,
    animation: "spin 1s linear infinite",
  },
  message: {
    color: "#3C3C3C",
    fontSize: "1.2rem",
    fontWeight: 500,
    textAlign: "center",
    // textShadow: "1px 1px 2px rgba(0,0,0,0.6)",
  },
  spinnerKeyframes: `
    @keyframes spin {
      0% { transform: rotate(0deg);}
      100% { transform: rotate(360deg);}
    }
  `,
};

// Inject keyframes only once
const injectKeyframes = () => {
  if (!document.getElementById("spinner-keyframes")) {
    const style = document.createElement("style");
    style.id = "spinner-keyframes";
    style.innerHTML = spinnerStyles.spinnerKeyframes;
    document.head.appendChild(style);
  }
};

const LoadingSpinner = ({ message = "Loading..." }) => {
  injectKeyframes();
  return (
    <div style={spinnerStyles.overlay}>
      <img
        src={`${process.env.PUBLIC_URL}/static/logo/ev_cred_icon.png`}
        alt="Loading..."
        style={spinnerStyles.spinner}
      />
      <div style={spinnerStyles.message}>{message}</div>
    </div>
  );
};

export default LoadingSpinner;
